import { addStyles } from './index.es.js';

var small = "mc86489d97_small";
var circle = "mc86489d97_circle";
var pill = "mc86489d97_pill";
var styles = ".mc86489d97_small{font-size:18px;letter-spacing:.3px;line-height:37px}.mc86489d97_small,.mc86489d97_small:after,.mc86489d97_small:before{border-radius:20px}.mc86489d97_small:focus:before{border-radius:33px}.mc86489d97_circle{align-items:center;display:flex;height:40px;justify-content:center;padding:0;text-align:center;width:40px}.mc86489d97_pill{max-height:40px;padding:0 24px}";

addStyles([{
  attributeName: 'size',
  attributeValue: 'small',
  className: small,
  styles: styles,
  variations: {
    circle: circle,
    pill: pill
  }
}]);
